import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App.jsx';
import './index.css';

Sentry.init({
  dsn: 'https://234c7902687fe9005b16ede29b1d16ac@o4511298306244608.ingest.us.sentry.io/4511298331082752',
  sendDefaultPii: true,
  environment: window.location.hostname === 'heyhub.ai' ? 'production' : 'staging'
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
